import { filterKeys } from "@website/accommodation-ui/constant/filterKeys";
import has from "lodash-es/has";
import without from "lodash-es/without";
import { useRouter } from "next/router";
export const HasFilters = () => {
  const router = useRouter();
  const filterKeysRooms = without(filterKeys, "hotelName", "stars");
  const hasFilter = () => filterKeys.some(key => has(router.query, key));
  const hasFilterRoom = () => filterKeysRooms.some(key => has(router.query, key));
  return {
    hasFilter,
    hasFilterRoom
  };
};